<template>
  <ConfigProvider :locale="getAntdLocale">
    <AppProvider>
      <RouterView />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
  import { ConfigProvider } from 'ant-design-vue';
  import { AppProvider } from '/@/components/Application';
  import { useTitle } from '/@/hooks/web/useTitle';
  import { useLocale } from '/@/locales/useLocale';

  import 'dayjs/locale/zh-cn';
  // support Multi-language
  const { getAntdLocale } = useLocale();

  // 判断从哪个地址跳转回来的
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  // 清除url中的code和state参数
  if (code) {
    localStorage.setItem('wxCode', code);
    urlParams.delete('code');
    urlParams.delete('state');
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
  } else {
    localStorage.removeItem('wxCode');
  }

  // Listening to page changes and dynamically changing site titles
  useTitle();
</script>
